module.exports = __webpack_public_path__ + "img/download.a33052f3.gif";